<ion-card>

    <ion-card-content>
        <ion-label *ngIf="document.documentType !== 7 && document.documentType !== 20 && document.documentType !== 18 ">Select Detail Lines...</ion-label>
        <ion-label *ngIf="document.documentType === 7">Materials Used</ion-label>
        <ion-label *ngIf="document.documentType === 20 || document.documentType === 18">Replacement Item</ion-label>
        
        <ion-fab vertical="center" horizontal="end" >
            <ion-row class="ion-no-margin ion-no-padding">
                <ion-col class="ion-no-margin ion-no-padding" *ngIf="mobileConfig.mobilehireHealthCareInUse === 1">
                    <ion-fab-button color="light" (click)="scanBarcode()" size="small">
                        <ion-icon name="barcode-sharp"></ion-icon>
                    </ion-fab-button>
                </ion-col>

                <ion-col class="ion-no-margin ion-no-padding"
                            *ngIf="mobileConfig && (document.documentType !== 7 || mobileConfig.mobilehireSimpleEquipOffhire !== 1)">
                    <ion-fab-button color="light" (click)="equipProdModal(2, false)" size="small">
                        <ion-icon name="hammer"></ion-icon>
                    </ion-fab-button>
                </ion-col>

                <ion-col class="ion-no-margin ion-no-padding"
                         *ngIf="mobileConfig && mobileConfig.mobilehireHealthCareInUse !== 1 && (document.documentType !== 8 || mobileConfig.mobilehireSimpleEquipOffhire !== 1)">
                    <ion-fab-button color="light" (click)="equipProdModal(1, false)" size="small">
                        <ion-icon name="cart"></ion-icon>
                    </ion-fab-button>
                </ion-col>



            </ion-row>
        </ion-fab>
    </ion-card-content>

    <ion-list *ngIf="document.detailLines.length > 0 && document.documentType !== 18">
        <ion-item-sliding *ngFor="let item of document.detailLines; index as i;" #slidingItem>
            
            <!-- Changover Item-->
            <ion-item (click)="editProdQtyService.editLine(item, document)" *ngIf="item.typ === 'S' && item.changeOverDetailLine && item.changeOverDetailLine !==null " class="ion-text-wrap">

                <ion-label class="ion-text-wrap">
                    <p>{{item.overrideDescriptionNote !==null ? item.overrideDescriptionNote : item.description }}</p>
                    <p>{{item.pdesc }} <span *ngIf="item.reg"> - {{item.reg}}</span></p>
                    <ion-icon color="none" name="arrow-down" slot="icon-only"></ion-icon>
                    <p>{{item.changeOverDetailLine.overrideDescriptionNote !==null ? item.changeOverDetailLine.overrideDescriptionNote : item.changeOverDetailLine.description }}</p>
                    <p>{{item.changeOverDetailLine.pdesc }} <span *ngIf="item.changeOverDetailLine.reg"> - {{item.changeOverDetailLine.reg}}</span></p>
               
  

                </ion-label>
            </ion-item>

            <!-- Single Item -->
            <ion-item (click)="editProdQtyService.editLine(item, document)" *ngIf="item.typ === 'S' &&  ( !item.changeOverDetailLine || item.changeOverDetailLine === null ) " class="ion-text-wrap">
                <ion-label class="ion-text-wrap">
                    <p>{{item.overrideDescriptionNote !==null ? item.overrideDescriptionNote : item.description }}</p>
                    <p>{{item.pdesc }} <span *ngIf="item.reg"> - {{item.reg}}</span></p>
                    <span *ngIf="item.stat === 7">Plant Sold</span>
                </ion-label>
            </ion-item>


            <!-- Swipe Right Button -->
            <ion-item-options side="start"  *ngIf="document.originalDocumentType !== 1">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button (tap)="document.detailLines.splice(i,1)">
                        <ion-icon color="danger" name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>

            <!-- Multiple or Package Item -->
            <ion-item (click)="editProdQtyService.editLine(item, document)" *ngIf="item.typ === 'M' || item.typ === 'P'">
                <ion-label class="ion-text-wrap"><p>{{item.qty}} - {{item.overrideDescriptionNote}}</p></ion-label>
                <!--p *ngIf="item.supplierRef !== null && item.supplierRef != '' "><b>Supplier Ref :</b> {{item.supplierRef}}</p-->
                <span *ngIf="item.stat === 7">Plant Sold</span>
            </ion-item>

            <!-- Another swipe button-->
            <!--ion-item-options side="start"  *ngIf="doc.originalDocumentType === 1">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button (tap)="document.detailLines.splice(i,1)">
                        <ion-icon color="danger" name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options-->

            <ion-item (click)="editProdQtyService.editLine(item, document)" *ngIf="item.plu">
                <ion-label class="ion-text-wrap">
                    <p>{{item.qty}} - {{item.comment}}</p>
                    <p *ngIf="item.supplierRef !== null && item.supplierRef != '' "><b>Supplier Ref :</b> {{item.supplierRef}}</p>
                </ion-label>
            </ion-item>

            <!-- yet another swipe item -->
            <!--ion-item-options side="start"  *ngIf="document.originalDocumentType !== 1">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button color="danger" (click)="deleteLine(i)">
                        <ion-icon name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options-->

            <!--"-->
            <ion-item-options side="start" *ngIf="document.originalDocumentType === 1 && item.pdesc !== null">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button color="secondary" (click)="openChangeoverEquipmentSearch(item,i)">
                        <ion-icon name="swap-horizontal" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>

            <ion-item-options side="end" *ngIf="document.originalDocumentType === 1 && item.changeOverDetailLine !== null">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button color="danger" (click)="clearChangeoverEquipment(item,i)">
                        <ion-icon name="swap-horizontal" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>

        </ion-item-sliding>
    </ion-list>

    <ion-list *ngIf="document.replacementItem && document.documentType === 18">
        <ion-item-sliding>
            
          

            <!-- Single Item -->
            <ion-item (click)="editProdQtyService.editLine(document.replacementItem, document)" *ngIf="document.replacementItem.typ === 'S' " class="ion-text-wrap">
                <ion-label class="ion-text-wrap">
                    <p>{{document.replacementItem.description }}</p>
                    <p>{{document.replacementItem.pdesc }} <span *ngIf="document.replacementItem.reg"> - {{document.replacementItem.reg}}</span></p>
                    <span *ngIf="document.replacementItem.stat === 7">Plant Sold</span>
                </ion-label>
            </ion-item>



            <!-- Multiple or Package Item -->
            <ion-item (click)="editProdQtyService.editLine(document.replacementItem, document)" *ngIf="document.replacementItem.typ === 'M' || document.replacementItem.typ === 'P'">
                <ion-label class="ion-text-wrap"><p>{{document.replacementItem.qty}} - {{document.replacementItem.overrideDescriptionNote}}</p></ion-label>
                <!--p *ngIf="item.supplierRef !== null && item.supplierRef != '' "><b>Supplier Ref :</b> {{item.supplierRef}}</p-->
                <span *ngIf="document.replacementItem.stat === 7">Plant Sold</span>
            </ion-item>

            <ion-item-options side="start"  *ngIf="document.originalDocumentType !== 1">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button color="none" (click)="document.replacementItem = null">
                        <ion-icon color="danger" name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>


        </ion-item-sliding>
    </ion-list>

</ion-card>
